import { useLocalSearchParams } from 'expo-router';

import { PageView } from '@/components/editor/PageView.web';

export default function PageScreen() {
  const { id } = useLocalSearchParams<{ id: string }>();
  const pageId = typeof id === 'string' ? id : id?.[0];
  return <PageView pageId={pageId} trackRecents />;
}
